module.exports = __webpack_public_path__ + "static/img/Resource-Management.941ebfba.jpg";